import Controller from '@ember/controller';

import { Router } from 'receivable-invoices-js/react/router';

export default class ReactController extends Controller {
  ReactRouter = Router;

  queryParams = ['code', 'state', 'error', 'error_description'];
}
